import "@tanstack/react-table" //or vue, svelte, solid, qwik, etc.
import { ColumnDef, ColumnFiltersState, Row, RowData, SortingState, Table } from "@tanstack/react-table"
import { ClpTableEnum } from "components/ClpTable/ClpTableEnum"
import { TFunction } from "i18next"

declare module "@tanstack/react-table" {
  interface ColumnMeta<TData extends RowData, TValue> {
    hiddenFilter?: boolean
    mainFilter?: boolean
    align?: "left" | "center" | "right"
    filter?: any
    filterHeader?: string
    tooltip?: string
    filterOptions?: { name: string; value: string | any }[]
  }
  interface InitialTableState {
    filters?: TableFilter[] | []
  }
}
export interface TableProps<T extends object> {
  rows: T[]
  columns: ColumnDef<T>[]
  subColumns?: ColumnDef<T>[]
  initialFilters?: TableFilter[]
  loadingState: TableLoadingStateEnum
  hideSearch?: boolean
  hideFilter?: boolean
  print?: boolean
  onRowClick?: (value: Row<T>) => void
  footer?: any[]
  totalSum?: any[]
  tableId?: ClpTableEnum
  serverSidePagination?: boolean
  pagedDataApiEndpoint?: string
  saveFilterTooltipText?: string
  noRowsErrorText?: string
  defaultSorting?: SortingState
}

export interface ServerSidePagingTableProps<T extends object> {
  columns: ColumnDef<T>[]
  subColumns?: ColumnDef<T>[]
  initialFilters?: TableFilter[]
  hideSearch?: boolean
  hideFilter?: boolean
  print?: boolean
  onRowClick?: (value: Row<T>) => void
  footer?: any[]
  totalSum?: any[]
  tableId?: ClpTableEnum
  /** URL to enpoint with ClpTablePaginationFilter as request body*/
  pagedDataApiEndpoint: string
  /** URL to enpoint with ClpTableColumnFilterDto[] as request body*/
  nonPagedDataApiEndpoint: string
  /** Update to manually trigger table refresh*/
  refreshKey?: number
  saveFilterTooltipText?: string
  noRowsErrorText?: string
}


export interface ConvertedTable {
  (rows: Row<any>[],
    columns: ColumnDef<any>[],
    t: TFunction<string>,
    tableId?: ClpTableEnum,
    footer?: any[],
  ): any[][]
}

export interface ExportExcelProps {
  convertedTable?: any[]
}

export interface ExportExcelProps2 {
  columns: ColumnDef<any>[]
  rows: [][]
}

export interface PrintToPdfProps {
  columns: ColumnDef<any>[]
  rows: Row<any>[]
}

export type SelectedFiltersProps = {
  table: Table<any>
  setFiltering: React.Dispatch<React.SetStateAction<ColumnFiltersState>>
}

export enum TableLoadingStateEnum {
  Loading = 1,
  Success = 2,
  Error = 3
}

export type TableFilter = {
  id: string
  value: any
}

export interface ClpTableColumnFilterDto {
  id: string
  value: string[]
}

export interface ClpTablePaginationFilter {
  filters: ClpTableColumnFilterDto[]
  page: number
  pageSize: number
  sortBy?: string
  sortDescending: boolean
}

export interface PagedResult<T> {
  items: T[]
  totalCount: number
  page: number
  pageSize: number
}
